// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__2BkTN","col":"CardReaderDesc_col__rdtEw","label":"CardReaderDesc_label__2rYh2"};